import { render, staticRenderFns } from "./UserUsageGroupCourseTable.vue?vue&type=template&id=618935e5&"
import script from "./UserUsageGroupCourseTable.vue?vue&type=script&lang=ts&"
export * from "./UserUsageGroupCourseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports